import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { RelativeTime } from "@design-system/RelativeTime/RelativeTime";
import styles from "./HistoryDetailsCells.module.scss";

interface RelativeDateCellProps {
    row: { original: { date?: Date; logDate?: Date } };
    dateField?: "date" | "logDate";
}

export const RelativeDateCell = memo(
    ({ row, dateField = "date" }: RelativeDateCellProps) => {
        const rawDate = row.original[dateField];

        if (!rawDate) {
            return <ViewTableCell className={styles.dateCell} />;
        }

        const date = new Date(rawDate);

        return (
            <ViewTableCell className={styles.dateCell}>
                <RelativeTime date={date} />
            </ViewTableCell>
        );
    },
);

RelativeDateCell.displayName = "RelativeDateCell";
